import { DataGridPro } from "@mui/x-data-grid-pro"
import { useState, useEffect } from "react"
export const IntervalComponent = ({value, setValue}: {value: string, setValue: (value: string) => void}) => {
    const [values, setValues] = useState([] as number[])
    const fields = ["First", "Second", "Third", "Fourth", "Fifth"]
    const columns = fields.map((column) => ({
        field: column,
        headerName: column,
        width: 100,
        editable: true,
    }))

    const rows = [{
        id:1,
        ...fields.reduce((acc, field, i) => ({
            ...acc,
            [field]: values[i],
        }), {})
    }]
    useEffect(() => {
        setValues(value.split(",").map(Number).map(i=>Math.round(i/60)))
    }, [value])

    const processRowUpdate = (newRow, oldRow) => {
        const newValues = [...values]
        const changedField = fields.findIndex(field => newRow[field] !== oldRow[field])
        if (changedField !== -1) {
            newValues[changedField] = newRow[fields[changedField]]
            setValues(newValues)
            setValue(newValues.map(i=>i*60).join(","))
        }
        return newRow
    }
    
    return <DataGridPro columns={columns} rows={rows} 
    hideFooter
    processRowUpdate={processRowUpdate}
    />
}